export { default } from "./SelectByLocale";
